module.exports = __webpack_public_path__ + "img/104.ba2f158e.jpg";